<template>
  <div class="flex items-center justify-center h-full" @click="openModal">
    {{teacherList.length}}

    <!-- Modal -->
    <div v-if="showTeacherListModal">
      <vs-popup
        class="holamundo"
        title="Enrolled Teachers"
        :active.sync="showTeacherListModal"
      >
        <vs-table :data="teacherList" class="cstm_vuexy_table">
          <template slot="thead">
            <vs-th style="width: 80px">Image</vs-th>
            <vs-th>Name</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].picture">
                <img
                  class="imgpic"
                  :src="data[indextr].picture ? data[indextr].picture : 'http://scoolio-dev.track-progress.com/img/user-circle-solid.c3580913.svg'"
                  style="height: 40px; width: 40px; object-fit: contain"
                />
              </vs-td>
              <vs-td>
                {{ data[indextr].first_name }}
                {{ data[indextr].last_name }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-popup>
    </div>

  </div>
</template>

<script>
export default {
  name: 'TeachersListAction',
  data () {
    return {
      showTeacherListModal: false,
      teacherList: []
    }
  },
  mounted () {
    this.prepareTeachersList()
  },
  methods: {
    openModal () {
      this.showTeacherListModal = true
    },
    closeModal () {
      this.showTeacherListModal = false
    },
    prepareTeachersList () {
      this.teacherList = []
      let teacherIdList = []
      this.params.data.enrolled_courses.forEach(ele => {
        if (Object.keys(ele).length > 0 && Object.keys(ele.enrolled_teacher).length > 0) {
          if (!teacherIdList.includes(ele.enrolled_teacher.id)) {
            this.teacherList = this.teacherList.concat(ele.enrolled_teacher)
            teacherIdList = teacherIdList.concat(ele.enrolled_teacher.id)
          }
        }
      })
    }
  }
}
</script>
